export default __webpack_public_path__ + "static/media/tab_7.56086800.svg";